import { FirestoreDocument } from './firestore-document';

export interface Category extends FirestoreDocument {
  name: string;
  subjectId?: string;
}

export enum YearSegment {
  WholeYear,
  FirstHalf,
  SecondHalf,
}
